import { withFormik } from 'formik';
import { validation, required } from '../../../forms/util/validation';
import * as yup from 'yup';
var validationSchema = yup.object().shape({
  reason: required('Reason for return is required'),
  number: required('Number to Return is required')
});
export var returnsFormikEnhancer = withFormik({
  enableReinitialize: false,
  validationSchema: validationSchema,
  handleSubmit: function handleSubmit(values, _ref) {
    var props = _ref.props;
    var reason = values.reason,
        number = values.number,
        comments = values.comments;

    var _ref2 = (props === null || props === void 0 ? void 0 : props.toReturn) || {},
        Id = _ref2.Id,
        orderNumber = _ref2.orderNumber;

    var data = {
      "OrderId": orderNumber,
      "LineId": Id,
      //Hard coded for return right now
      "OrderStatus": "MarkedForReturn",
      "Quantity": number,
      "Reason": reason,
      "Comments": comments || ""
    };
    props.postGuestReturn(data); // props.setShowAddressForm(false);
    // props.setActiveAddress({});
  },
  displayName: 'Retail Guest Form' // helps with React DevTools

});